import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { taskTransferM } from 'src/app/Models/BasicForms/taskTransferM';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-task-transfer-drawer',
  templateUrl: './task-transfer-drawer.component.html',
  styleUrls: ['./task-transfer-drawer.component.css'],
  providers: [DatePipe]
})

export class TaskTransferDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: taskTransferM;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.loadAllTasks();
    this.loadAllToUsers();
  }

  taskList = [];
  loadAllTasks() {
    this._apiService.getAllTaskSubtask(0, 0, 'ID', 'desc', '').subscribe(taskData => {
      this.taskList = taskData['data'];

    }, err => {

    });
  }

  toUserList = [];
  loadAllToUsers() {
    this._apiService.getAllUsers(0, 0, 'ID', 'desc', '').subscribe(userData => {
      this.toUserList = userData['data'];

    }, err => {

    });
  }

  isSpinning = false;
  logtext: string = "";

  save(addNew: boolean): void {
    var isOk = true;

    if (isOk) {
      this.isSpinning = true;

      this.data.TRANSFER_DATETIME = new Date();
      this.data.TRANSFER_DATETIME = this.datePipe.transform(this.data.TRANSFER_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data.FROM_USER_ID = this._apiService.userId;



      if (!this.data.ID) {
        this._apiService.createTaskTransferHistory(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Transfer History Added Successfully", "");

            if (!addNew) {
              this.drawerClose();

              this.logtext = 'Save & Close - Task Transfer form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Transfer ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              // this.data = new taskTransferM();

              this.logtext = 'Save & New - Task Transfer form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Transfer ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Task Transfer", "");
            this.logtext = 'Save & Close - Task Transfer form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Transfer ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateTaskTransferHistory(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Task Transfer Updated Successfully", "");
            this.logtext = 'Update & Close - Task Transfer form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Transfer ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Task Transfer", "");
            this.logtext = 'Update & Close - Task Transfer form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Task Transfer ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  close(clientMasterPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(clientMasterPage);
  }

  resetDrawer(clientMasterPage: NgForm) {
    this.isSpinning = false;
    // clientMasterPage.form.reset();
    this.data = new taskTransferM();
  }
}
